import React from "react";
import * as ReactDOMClient from 'react-dom/client';
import MissionSlider from "../Common/MissionSlider";
const GroupMissions = () => {
    // @ts-ignore
    const missions = Object.values(window.missions);
    const sliderMissions = missions?.map((mission) => ({
        id: +mission.id,
        type: "group",
        name: mission.name,
        slug: mission.slug,
        groupName: mission.group_name,
        missionGoal: +mission.mission_goal,
        startDate: mission.start_date,
        distanceUnit: mission.distance_unit,
        isConqueror: false,
        exerciseTypes: mission.exercise_types.map((t) => t.alias.replace("-", "_")),
        imgAvatar: mission.avatar_image,
        distancePct: +mission.distance_pct,
        isFundraising: mission.is_fundrasing,
        participantsCt: +mission.participants,
    })) || [];
    return React.createElement(MissionSlider, { missions: sliderMissions });
};
const rctGroupMissions = document.getElementById("rct-group-missions");
if (rctGroupMissions !== null) {
    ReactDOMClient.createRoot(rctGroupMissions).render(React.createElement(GroupMissions, null));
}
